import { Drawer } from "antd";
import { AlpacaActivityDetailsProps } from "./types";
import { BackButton } from "components/BackButton";
import { useAlpacaActivitiesUtils } from "components/AlpacaActivitiesScroll/useAlpacaActivitiesUtils";
import { useIntl } from "react-intl";
import { messages } from "./messages";
import dayjs from "dayjs";
import { useFormatter } from "hooks/utils/useFormatter";
import { useTranslationConstants } from "hooks/utils/useTranslationConstants";
import { DetailsField } from "components/DetailsField";
import { MERK_ACTIVITY_TYPE, MERK_ORDER_SIDE } from "@letsbit/malcolmlb";

export const AlpacaActivityDetails: React.FC<AlpacaActivityDetailsProps> = ({
  activity,
  onClose,
}) => {
  const { getMerkOperationInfo } = useAlpacaActivitiesUtils();
  const { formatMessage } = useIntl();
  const { formatValue } = useFormatter();
  const { getMerkActivityStatus } = useTranslationConstants();

  return (
    <Drawer
      width="33%"
      placement="right"
      keyboard={true}
      closable={false}
      onClose={onClose}
      open={!!activity}
      getContainer=".ion-root"
    >
      <div className="flex flex-col gap-y-6">
        <BackButton onClick={onClose} />
        {activity && (
          <div className="flex flex-col gap-y-6 pdf:p-10">
            <h2 className="text-2xl font-bold text-[--milkylb-color-neutral-400]">
              {getMerkOperationInfo(activity).title}
            </h2>
            <DetailsField
              label={formatMessage(messages.asset)}
              value={getMerkOperationInfo(activity).asset.toUpperCase()}
            />
            <DetailsField
              label={formatMessage(messages.amount)}
              value={`${formatValue(getMerkOperationInfo(activity).amount)} ${getMerkOperationInfo(activity).currency?.toUpperCase() || ""}`}
            />
            {activity.type === MERK_ACTIVITY_TYPE.ORDER && (
              <DetailsField
                label={
                  activity.data.side === MERK_ORDER_SIDE.BUY
                    ? formatMessage(messages.received)
                    : formatMessage(messages.sended)
                }
                value={`${activity.data.quantity} ${getMerkOperationInfo(activity).asset?.toUpperCase() || ""}`}
              />
            )}
            <DetailsField
              label={formatMessage(messages.status)}
              value={getMerkActivityStatus(activity).translate}
            />
            <DetailsField
              label={formatMessage(messages.date)}
              value={dayjs(getMerkOperationInfo(activity).date).format(
                "DD.MM.YYYY HH:mm",
              )}
            />
            <DetailsField
              label={formatMessage(messages.tid)}
              value={activity.id}
            />
          </div>
        )}
      </div>
    </Drawer>
  );
};
